import * as React from "react";
import AutodeskLogo from "../../assets/mx-autodesk-dark.png";

export default function Logo(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-label="MaintainX, an Autodesk company"
      role="img"
      width={611}
      height={153}
      {...props}
      viewBox="0 0 611 153"
    >
      <image href={AutodeskLogo.src} width={611} height={153} />
    </svg>
  );
}
